import {
    Button,
    Divider,
    Icon,
    ListItem,
    ListItemIcon,
    ListItemText,
    Paper,
    Stack,
    Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { HelpIconButton, PageHeader } from "../../../components/exports";
import { RootState } from "../../../slices/Store";
import { GetSmsCampaignTypesList } from "../constants/SmsCampaignContants";
import {
    SmsCampaignType,
    setSmsCampaignType,
} from "../smsCampaignSlice/SmsCampaignSlice";
import SmsCampaignPrivateGatewayNumberAlert from "./SmsCampaignPrivateGatewayNumberAlert";

// updated
export default function SmsCampaignSelectType() {
    const dispatch = useDispatch();
    const smsCampaign = useSelector((state: RootState) => state.smsCampaign);
    const partCount = useSelector(
        (state: RootState) => state.shared.accountDetail.partCount
    );

    const onDestinationTypeSelected = (type: SmsCampaignType) => {
        dispatch(setSmsCampaignType(type));
    };

    return (
        <>
            <PageHeader
                title="انتخاب نوع کمپین"
                action={
                    <Stack direction="row" spacing={2} alignItems="center">
                        <HelpIconButton tag="sms" />
                        <Typography color="text.secondary" fontSize="small">
                            شارژ پیامکی {partCount} عدد
                        </Typography>
                    </Stack>
                }
            />

            <Paper>
                <Stack divider={<Divider />}>
                    {GetSmsCampaignTypesList.map((i) => {
                        return (
                            <ListItem
                                sx={{ color: i.color }}
                                key={i.type}
                                secondaryAction={
                                    <Button
                                        variant="contained"
                                        onClick={() =>
                                            onDestinationTypeSelected(i.type)
                                        }
                                    >
                                        تایید
                                    </Button>
                                }
                            >
                                <ListItemIcon>
                                    <Icon
                                        fontSize="large"
                                        sx={{ color: i.color }}
                                    >
                                        {i.icon}
                                    </Icon>
                                </ListItemIcon>

                                <ListItemText
                                    primary={i.title}
                                    secondary={i.description}
                                />
                            </ListItem>
                        );
                    })}
                </Stack>
            </Paper>

            <SmsCampaignPrivateGatewayNumberAlert />
        </>
    );
}
